import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './utils/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import Layout from './components/Layout/Layout';
import PredictionForm from './components/PredictionForm';
import RecipeGenerator from './components/RecipeGenerator';
import ExploreData from './components/ExploreData';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Protected Routes with Layout */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/predict" replace />} />
            <Route path="predict" element={<PredictionForm />} />
            <Route path="recipe" element={<RecipeGenerator />} />
            <Route path="explore" element={<ExploreData />} />
            
            {/* Admin Routes */}
            <Route
              path="admin/users"
              element={
                <ProtectedRoute adminOnly>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* Catch all - redirect to predict */}
          <Route path="*" element={<Navigate to="/predict" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
